<template>
  <v-content class="pa-12">
    <v-layout style="background-color: #faf5f2">
      <v-flex>
        <v-flex shrink style="text-align: right"
          ><v-btn
            @click="printPage()"
            dark
            style="width: 80px; background-color: black"
            ><v-icon>local_printshop</v-icon></v-btn
          ></v-flex
        >
        <!-- Nevigater -->
        <v-layout mb-12 v-if="$route.query.name === 'verify-rf'">
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>ตรวจสอบแบบฟอร์ม RF</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานการเบี่ยงเบนโครงร่างวิจัย</span>
          </v-flex>
        </v-layout>
        <v-layout v-else mb-12>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            class="nevigater-link"
            @click="$router.go(-1)"
          >
            <span>Post Approve</span>
          </v-flex>
          <v-flex shrink d-flex justify-start align-center>
            <v-icon color="#3E7662">arrow_right</v-icon>
          </v-flex>
          <v-flex
            shrink
            d-flex
            justify-start
            align-center
            style="color: #3e7662; font-weight: bold; font-size: 24px"
          >
            <span>รายงานการเบี่ยงเบนโครงร่างวิจัย</span>
          </v-flex>
        </v-layout>

        <div id="print" style="height: auto">
          <div class="print-form">
            <v-layout>
              <v-flex>
                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: left; font-size: 28px; color: white"
                  >
                    <div style="font-weight: bold">
                      แบบรายงานการไม่ปฏิบัติตามข้อกำหนด
                    </div>
                    <div style="font-size: 18px">
                      Non-compliance / Protocol Deviation / Prootocol Violation
                      Report
                    </div>
                  </v-flex>
                  <v-flex
                    ml-8
                    pt-8
                    pr-8
                    style="
                      text-align: right;
                      font-weight: bold;
                      font-size: 13px;
                      color: white;
                    "
                  >
                    <span>RF 05_2563</span>
                  </v-flex>
                </v-layout>
                <!-- blog 1 -->
                <v-card class="mb-12 px-12">
                  <v-layout py-12 pr-8 mr-12 style="font-size: 16px">
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout pt-8>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>รหัสโครงร่างการวิจัย</span>
                        </v-flex>
                        <v-flex xs4>
                          <textfield-form
                            :model="form.researchCode"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ชื่อผู้วิจัยหลัก</span>
                        </v-flex>
                        <v-flex xs4>
                          <textfield-form
                            :model="form.firstName"
                            readonly
                          ></textfield-form>
                        </v-flex>
                        <v-flex
                          xs2
                          pr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>นามสกุล</span>
                        </v-flex>
                        <v-flex xs4>
                          <textfield-form
                            :model="form.lastName"
                            readonly
                          ></textfield-form>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout pb-6>
                        <v-flex
                          xs2
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <span>ชื่อโครงการวิจัย (ไทย)</span>
                        </v-flex>
                        <v-flex xs10>
                          <textarea-form
                            :model="form.researchName"
                            readonly
                          ></textarea-form>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!--blog 2-->
                <v-card class="mb-12">
                  <v-layout py-12 px-8>
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout pt-8>
                        <v-flex xs4>
                          <v-layout>
                            <v-flex
                              xs4
                              mr-2
                              pt-2
                              style="text-align: right; font-weight: bold"
                            >
                              <span>จำนวนรายงาน</span>
                            </v-flex>
                            <v-flex xs8>
                              <textfield-form
                                :model="form.amountOfReport"
                                readonly
                              ></textfield-form>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs8>
                          <v-layout>
                            <v-flex
                              xs6
                              mr-2
                              pt-2
                              style="text-align: right; font-weight: bold"
                            >
                              <span
                                >จำนวนอาสาสมัครที่มีการไม่ปฏิบัติตามข้อกำหนด</span
                              >
                            </v-flex>
                            <v-flex xs6>
                              <textfield-form
                                :model="form.amountOfNotFollow"
                                readonly
                              ></textfield-form>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <!-- row 2 -->
                      <div v-for="(input, k) in subjectData" :key="k">
                        <v-layout>
                          <v-flex xs4>
                            <v-layout>
                              <v-flex
                                xs4
                                mr-2
                                pt-2
                                style="text-align: right; font-weight: bold"
                              >
                                <span>Subject No.</span>
                              </v-flex>
                              <v-flex xs8>
                                <textfield-form
                                  :model="input.subjectNumber"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-flex xs8>
                            <v-layout justify-space-around>
                              <v-flex
                                ml-6
                                mr-n3
                                shrink
                                pt-2
                                style="font-weight: bold"
                              >
                                <span>Date of Events</span>
                              </v-flex>
                              <v-flex xs2>
                                <textfield-form
                                  :model="input.dateOfEvents"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                              <v-flex
                                mr-n4
                                shrink
                                pt-2
                                style="text-align: right; font-weight: bold"
                              >
                                <span>Date of Acknowledgement</span>
                              </v-flex>
                              <v-flex xs2>
                                <textfield-form
                                  :model="input.dateOfAcknowledgement"
                                  readonly
                                ></textfield-form>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!--blog 3-->

                <!--blog 3-->

                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: center; font-size: 18px; color: white"
                  >
                    <div style="font-weight: bold">Type of Report</div>
                  </v-flex>
                </v-layout>
                <v-card flat class="mb-12 px-12 py-12">
                  <!--group 1-->
                  <v-layout px-12>
                    <v-flex
                      xs4
                      :class="!form.hasDeviation ? '' : 'color-label-checkbox'"
                      style="font-weight: bold; font-size: 18px"
                      d-flex
                      justify-start
                    >
                      <v-checkbox
                        readonly
                        v-model="form.hasDeviation"
                        color="#3E7662"
                        label="Protocol Deviation"
                        @change="clearCheckbox('hasDeviation')"
                      ></v-checkbox>
                    </v-flex>
                    <v-flex
                      xs4
                      :class="!form.hasDeviation ? '' : 'color-label-checkbox'"
                      style="font-weight: bold; font-size: 18px"
                      d-flex
                      justify-start
                    >
                      <v-checkbox
                        readonly
                        v-model="form.hasProtocol"
                        color="#3E7662"
                        label="Protocol Violation"
                        @change="clearCheckbox('hasProtocol')"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout mt-2 style="padding-left: 100px">
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout>
                        <v-flex
                          mt-n4
                          shrink
                          :class="!form.hasRandom ? '' : 'color-label-checkbox'"
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasDeviation"
                            v-model="form.hasRandom"
                            hide-details
                            color="#3E7662"
                            label="สุ่มอาสาสมัครที่ไม่มีคุณสมบัติเหมาะสม (Randomization of ineligible subjects)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasRandom"
                            :model="form.randomEventNumber"
                            @update-data="
                              updateData('randomEventNumber', $event)
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasEnrollment ? '' : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasDeviation"
                            v-model="form.hasEnrollment"
                            hide-details
                            color="#3E7662"
                            label="รับอาสาสมัครที่เข้าข่ายคัดออกจากโครงการ (Enrollment of excluded subjects)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasEnrollment"
                            :model="form.enrollmentEventNumber"
                            @update-data="
                              updateData('enrollmentEventNumber', $event)
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasNotScreening ? '' : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasDeviation"
                            v-model="form.hasNotScreening"
                            hide-details
                            color="#3E7662"
                            label="ไม่ได้ทำตามขั้นตอนการคัดกรองที่ระบุ (Do not perform screening procedures required by protocol)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasNotScreening"
                            :model="form.notScreeningEventNumber"
                            @update-data="
                              updateData('notScreeningEventNumber', $event)
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasScreening ? '' : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasDeviation"
                            hide-details
                            color="#3E7662"
                            v-model="form.hasScreening"
                            label="ดำเนินการคัดกรองหรือขั้นตอนการวิจัยนอกระยะเวลาที่กำหนด (Perform screening or procedures outside the time required by protocal)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasScreening"
                            :model="form.screeningEventNumber"
                            @update-data="
                              updateData('screeningEventNumber', $event)
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!--row 5-->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasFailureTherapy
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasDeviation"
                            hide-details
                            color="#3E7662"
                            v-model="form.hasFailureTherapy"
                            label="ให้การรักษา หรือให้ยาไม่ตรงตามที่ระบุ (Failure to provide therapy or mendication by protocal)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasFailureTherapy"
                            :model="form.failureTherapyEventNumber"
                            @update-data="
                              updateData('failureTherapyEventNumber', $event)
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!--row6-->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasFailureAccomplish
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasDeviation"
                            hide-details
                            color="#3E7662"
                            v-model="form.hasFailureAccomplish"
                            label="ทำหัตถการวิจัยที่ระบุไว้ไม่ครบถ้วน (Failure to accomplish procedures required by protocal)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasFailureAccomplish"
                            :model="form.failureAccomplishEventNumber"
                            @update-data="
                              updateData('failureAccomplishEventNumber', $event)
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!--row7-->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasFollowUp ? '' : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasDeviation"
                            hide-details
                            color="#3E7662"
                            v-model="form.hasFollowUp"
                            label="นัดหมายไม่ตรงตามระบุ (Follow-up visit outside the time schedule required by protocal"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasFollowUp"
                            :model="form.followUpEventNumber"
                            @update-data="
                              updateData('followUpEventNumber', $event)
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!--row8-->
                      <v-layout>
                        <v-flex
                          shrink
                          :class="!form.hasOther1 ? '' : 'color-label-checkbox'"
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasDeviation"
                            hide-details
                            color="#3E7662"
                            v-model="form.hasOther1"
                            label="อื่นๆ (Others) ระบุ"
                            @change="clearCheckbox('hasOther1')"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex mt-2 ml-3 xs8>
                          <textfield-form-append
                            readonly
                            :disabled="!form.hasOther1"
                            :model="form.other1"
                            @update-data="updateData('other1', $event)"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>

                  <!--group2-->

                  <v-layout px-12 pt-12>
                    <v-flex
                      xs6
                      :class="
                        !form.hasNonCompliance ? '' : 'color-label-checkbox'
                      "
                      style="font-weight: bold; font-size: 18px"
                      d-flex
                      justify-start
                    >
                      <v-checkbox
                        readonly
                        v-model="form.hasNonCompliance"
                        color="#3E7662"
                        label="Non-Compliance"
                        @change="clearCheckbox('hasNonCompliance')"
                      ></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-layout mt-2 style="padding-left: 100px">
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasDelaySAEReport
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasNonCompliance"
                            v-model="form.hasDelaySAEReport"
                            hide-details
                            color="#3E7662"
                            label="ส่งรายงานเหตุการณ์ไม่พึงประสงค์ชนิดร้ายแรงล่าช้า (Delay sending SAE report)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasDelaySAEReport"
                            :model="form.delaySAEReportEventNumber"
                            @update-data="
                              updateData('delaySAEReportEventNumber', $event)
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasDelayContinuingReport
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasNonCompliance"
                            v-model="form.hasDelayContinuingReport"
                            hide-details
                            color="#3E7662"
                            label="ส่งรายงานความก้าวหน้าของการวิจัยล่าช้า (Delay sending continuing report)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasDelayContinuingReport"
                            :model="form.delayContinuingReportEventNumber"
                            @update-data="
                              updateData(
                                'delayContinuingReportEventNumber',
                                $event
                              )
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasUseUnstampedInformed
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasNonCompliance"
                            v-model="form.hasUseUnstampedInformed"
                            hide-details
                            color="#3E7662"
                            label="ใช้เอกสารชี้แจงข้อมูลแก่อาสาสมัครฉบับที่ไม่ประทับตรายางของคณะกรรมการกลางฯ (Use unstamped informed consent form)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasUseUnstampedInformed"
                            :model="form.useUnstampedInformedEventNumber"
                            @update-data="
                              updateData(
                                'useUnstampedInformedEventNumber',
                                $event
                              )
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout mt-4>
                        <v-flex
                          mt-n4
                          shrink
                          :class="
                            !form.hasAccountabilityDrug
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasNonCompliance"
                            hide-details
                            color="#3E7662"
                            v-model="form.hasAccountabilityDrug"
                            label="การบริหารจัดการผลิตภัณฑ์ยาที่ใช้ในการวิจัยที่เหมาะสม (Impropor drug accountability)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs1>
                          <textfield-form-append
                            readonly
                            hide-detail=""
                            :disabled="!form.hasAccountabilityDrug"
                            :model="form.accountabilityDrugEventNumber"
                            @update-data="
                              updateData(
                                'accountabilityDrugEventNumber',
                                $event
                              )
                            "
                          />
                        </v-flex>
                        <v-flex style="text-align: left">
                          <span>เหตุการณ์</span>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex
                          shrink
                          :class="!form.hasOther2 ? '' : 'color-label-checkbox'"
                        >
                          <v-checkbox
                            readonly
                            :disabled="!form.hasNonCompliance"
                            hide-details
                            color="#3E7662"
                            v-model="form.hasOther2"
                            label="อื่นๆ (Others) ระบุ"
                            @change="clearCheckbox('hasOther2')"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex mt-2 ml-3 xs8>
                          <textfield-form-append
                            readonly
                            :disabled="!form.hasOther2"
                            :model="form.other2"
                            @update-data="updateData('other2', $event)"
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: center; font-size: 18px; color: white"
                  >
                    <div style="font-weight: bold">
                      รายละเอียดของการไม่ปฏิบัติตามระเบียบข้อกำหนด (Narrative
                      summary of the event
                    </div>
                  </v-flex>
                </v-layout>
                <!-- blog 4 -->
                <v-card class="mb-12 px-12">
                  <v-layout py-12 style="font-size: 16px">
                    <v-flex>
                      <textarea-form
                        :model="form.summaryOfTheEvent"
                        :rows="10"
                        background-color="#FBF6F3"
                        readonly
                      ></textarea-form>
                    </v-flex>
                  </v-layout>
                </v-card>

                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: center; font-size: 18px; color: white"
                  >
                    <div style="font-weight: bold">
                      การตอบสนอง (Action Taken)
                    </div>
                  </v-flex>
                </v-layout>
                <!-- blog 5 -->
                <v-card class="mb-12 px-12">
                  <v-layout py-12 mt-2 style="padding-left: 70px">
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout>
                        <v-flex
                          :class="
                            !form.hasSubjectWithdraw
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            v-model="form.hasSubjectWithdraw"
                            hide-details
                            color="#3E7662"
                            label="ถอนอาสาสมัครการวิจัย (Subject withdrawn)"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout>
                        <v-flex
                          :class="
                            !form.hasSubjectWithdrawWithFollowUp
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            v-model="form.hasSubjectWithdrawWithFollowUp"
                            hide-details
                            color="#3E7662"
                            label="ถอนอาสาสมัครการวิจัย และติดตาม (Subject withdrawn with follow up visit required)"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <!--row 3-->
                      <v-layout>
                        <v-flex
                          :class="
                            !form.hasSubjectRemainButFollow
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            v-model="form.hasSubjectRemainButFollow"
                            hide-details
                            color="#3E7662"
                            label="อาสาสมัครยังคงอยู่ในการวิจัย แต่ติดตามสังเกตอาการอสสาสมัครอย่างใกล้ชิด (Subject remains on the but data analysis will be modified)"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout>
                        <v-flex
                          :class="
                            !form.hasSubjectRemainButStudy
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            v-model="form.hasSubjectRemainButStudy"
                            hide-details
                            color="#3E7662"
                            label="อาสาสมัครยังคงอยู่ในการวิจัย แต่ปรับแก้ไขการวิเคราะห์ข้อมูลทางสถิติ (Subject remains on the study but data analysis will be modified)"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout>
                        <v-flex
                          shrink
                          :class="
                            !form.hasSponsorNotified
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            hide-details
                            color="#3E7662"
                            v-model="form.hasSponsorNotified"
                            label="แจ้งผู้สนับสนุนทุนวิจัยหรือผู้วิจัยหลัก Sponsor or Principle Investigator notified on date"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex ml-3 xs3>
                          <textfield-form-append
                            :disabled="!form.hasSponsorNotified"
                            :model="form.sponsorNotifiedOnDate"
                            readonly
                          />
                        </v-flex>
                      </v-layout>

                      <v-layout>
                        <v-flex
                          mt-1
                          shrink
                          :class="!form.hasOther3 ? '' : 'color-label-checkbox'"
                        >
                          <v-checkbox
                            readonly
                            hide-details
                            color="#3E7662"
                            v-model="form.hasOther3"
                            label="อื่นๆ (Others) ระบุ"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex ml-3 xs8>
                          <textfield-form-append
                            :disabled="!form.hasOther3"
                            :model="form.other3"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <!--blog 6-->
                <v-card class="mb-12 px-12">
                  <v-layout py-12 pl-12 pr-8 mr-12 style="font-size: 16px">
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout>
                        <v-flex
                          mr-4
                          pt-2
                          style="text-align: left; font-weight: bold"
                        >
                          <span
                            >การปฏิบัติตามข้อกำหนดมีผลเพิ่มความเสี่ยงหรือเกิดอันตรายต่ออาสาสมัคร
                            หรือไม่</span
                          >
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout>
                        <v-flex mr-4 style="text-align: left">
                          <span
                            >Does it have or post a significant rick or
                            substantive harm to research subjects?</span
                          >
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout pb-6>
                        <v-flex
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <v-radio-group v-model="form.hasIncreaseRisk" row>
                            <v-radio
                              color="#3E7662"
                              style="padding-right: 100px"
                              label="มี"
                              value="0"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              label="ไม่มี"
                              value="1"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!--row 4-->
                      <v-layout>
                        <v-flex
                          pt-6
                          mr-4
                          style="text-align: left; font-weight: bold"
                        >
                          <span
                            >การปฏิบัติตามข้อกำหนดมีผลต่อความน่าเชื่อถือของงานวิจัย
                            หรือไม่</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex mr-4 pt-2 style="text-align: left">
                          <span
                            >Does it cause damage to the scientific integrity of
                            data collected? หรือไม่</span
                          >
                        </v-flex>
                      </v-layout>
                      <!-- row 5 -->
                      <v-layout pb-6>
                        <v-flex
                          mr-4
                          pt-2
                          style="text-align: right; font-weight: bold"
                        >
                          <v-radio-group v-model="form.hasCauseDamage" row>
                            <v-radio
                              color="#3E7662"
                              style="padding-right: 100px"
                              label="มี"
                              value="0"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              label="ไม่มี"
                              value="1"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>

                <v-layout mt-3 style="background-color: #3e7662">
                  <v-flex
                    my-8
                    ml-8
                    style="text-align: center; font-size: 18px; color: white"
                  >
                    <div style="font-weight: bold">
                      มีการดำเนินการหรือมาตรการที่จะป้องกันการเกิดเหตุการณ์ซ้ำหรือไม่?
                      <br />
                    </div>
                    <div>
                      Which corrective actions or plans to prevent the future
                      events?
                    </div>
                  </v-flex>
                </v-layout>
                <!-- blog 7 -->
                <v-card class="mb-12 px-12">
                  <v-layout pt-12 mt-2 style="padding-left: 70px">
                    <v-flex>
                      <!-- row 1 -->
                      <v-layout>
                        <v-flex
                          :class="
                            !form.hasRetraining ? '' : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            v-model="form.hasRetraining"
                            hide-details
                            color="#3E7662"
                            label="อบรบทีมวิจัยเกี่ยวกับวิธีดำเนินการวิจัยหรือหัตถการในโครงการวิจัย (retraining the research team about the research procedure on date "
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs3 ml-3>
                          <textfield-form-append
                            hide-detail
                            :disabled="!form.hasRetraining"
                            :model="form.retraining"
                            readonly
                          />
                        </v-flex>
                      </v-layout>
                      <!-- row 2 -->
                      <v-layout>
                        <v-flex
                          mt-1
                          shrink
                          :class="
                            !form.hasGCPTraining ? '' : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            v-model="form.hasGCPTraining"
                            hide-details
                            color="#3E7662"
                            label="อบรบการปฏิบัติการทางคลินิกที่ดี (ICH GCP training on"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex xs3 class="text-start" ml-3>
                          <textfield-form-append
                            hide-detail
                            :disabled="!form.hasGCPTraining"
                            :model="form.GCPTraining"
                            readonly
                          />
                        </v-flex>
                        <v-flex mt-3 shrink>
                          <span>)</span>
                        </v-flex>
                      </v-layout>
                      <!--row 3-->
                      <v-layout>
                        <v-flex
                          shrink
                          :class="
                            !form.hasHireStaff ? '' : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            v-model="form.hasHireStaff"
                            hide-details
                            color="#3E7662"
                            label="เพิ่มเจ้าหน้าที่หรือผู้ร่วมวิจัย (Hire more staffs or co-researchers)"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                      <!-- row 3 -->
                      <v-layout>
                        <v-flex
                          mt-1
                          shrink
                          :class="
                            !form.hasIncreaseSecurity
                              ? ''
                              : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            v-model="form.hasIncreaseSecurity"
                            hide-details
                            color="#3E7662"
                            label="เพิ่มความปลอดภัยของข้อมูล (Increase sata security by)"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex class="text-start" ml-3>
                          <textfield-form-append
                            hide-detail
                            :disabled="!form.hasIncreaseSecurity"
                            :model="form.increaseSecurity"
                            readonly
                          />
                        </v-flex>
                        <v-flex mt-3 shrink>
                          <span>)</span>
                        </v-flex>
                      </v-layout>
                      <!-- row 4 -->
                      <v-layout>
                        <v-flex
                          mt-1
                          shrink
                          :class="
                            !form.hasFixOldMachine ? '' : 'color-label-checkbox'
                          "
                        >
                          <v-checkbox
                            readonly
                            hide-details
                            color="#3E7662"
                            v-model="form.hasFixOldMachine"
                            label="ซ่อมหรือจัดหาเครื่องมือทดแทน (Fix or Replace the old machine)"
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>

                      <v-layout>
                        <v-flex
                          mt-1
                          shrink
                          :class="!form.hasOther4 ? '' : 'color-label-checkbox'"
                        >
                          <v-checkbox
                            readonly
                            hide-details
                            color="#3E7662"
                            v-model="form.hasOther4"
                            label="อื่นๆ (Others) ระบุ"
                          ></v-checkbox>
                        </v-flex>
                        <v-flex class="text-start" ml-3>
                          <textfield-form-append
                            hide-detail
                            :disabled="!form.hasOther4"
                            :model="form.other4"
                            readonly
                          />
                        </v-flex>
                        <v-flex mt-3 shrink>
                          <span>)</span>
                        </v-flex>
                      </v-layout>

                      <v-layout class="my-12">
                        <v-flex>
                          <v-layout class="mb-8">
                            <v-flex>
                              <v-layout>
                                <v-flex shrink pr-4 style="text-align: left">
                                  <span
                                    style="font-weight: bold; font-size: 16px"
                                    >หนังสือของหน่วยงาน :
                                  </span>
                                </v-flex>
                                <v-flex shrink>
                                  <span
                                    v-if="agencyBook"
                                    class="text-start linkPDF"
                                    style="font-size: 16px; color: #cc3d45"
                                    @click="open"
                                  >
                                    {{ agencyBook }}
                                  </span>
                                  <span
                                    v-else
                                    class="text-start"
                                    style="font-size: 12px; color: #cc3d45"
                                  >
                                    -
                                  </span>
                                </v-flex>
                                <v-spacer></v-spacer>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                          <v-layout>
                            <v-flex xs6>
                              <v-layout>
                                <v-flex
                                  class="d-flex align-center mr-4 font-weight-bold"
                                  shrink
                                  >เลขหนังสือ</v-flex
                                >
                                <v-flex>
                                  <textfield-form
                                    readonly
                                    hide-detail
                                    :model="form.bookNumber"
                                  ></textfield-form>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs6>
                              <v-layout>
                                <v-flex
                                  class="d-flex align-center mx-4 font-weight-bold"
                                  shrink
                                  >วันที่หนังสือ</v-flex
                                >
                                <v-flex>
                                  <textfield-form
                                    hide-detail
                                    readonly
                                    :model="form.bookDate"
                                  ></textfield-form>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex xs6 mt-5>
                              <v-layout>
                                <v-flex
                                  class="d-flex align-center mr-4 font-weight-bold"
                                  shrink
                                  >หน่วยงานที่ออกหนังสือ</v-flex
                                >
                                <v-flex>
                                  <textfield-form
                                    hide-detail
                                    :model="form.instituteBook"
                                    @updata\e-data="
                                      updateData('instituteBook', $event)
                                    "
                                  ></textfield-form>
                                </v-flex>
                              </v-layout>
                              <div
                                v-for="(input, k) in form.fileOther"
                                :key="'d' + k"
                                class="my-5"
                              >
                                <v-layout>
                                  <v-flex>
                                    <v-layout>
                                      <v-flex
                                        shrink
                                        mr-4
                                        pt-2
                                        style="text-align: right;font-weight: bold;"
                                      >
                                        <span>ชื่อไฟล์</span>
                                      </v-flex>
                                      <v-flex xs2>
                                        <textfield-form
                                          hide-detail
                                          :model="input.title"
                                        ></textfield-form>
                                      </v-flex>
                                      <v-flex v-if="input.filePath"
                                        ><a
                                          :href="input.filePath"
                                          target="_blank"
                                          style="color: #3e7662;text-align: center"
                                          class="link-hover"
                                        >
                                          <p>
                                            ไฟล์ที่อัพโหลด: {{ input.file }}
                                          </p>
                                        </a>
                                      </v-flex>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                                <v-layout> </v-layout>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-layout
                        pb-8
                        mb-8
                        style="
                          background-color: white;
                          padding-right: 70px;
                          padding-top: 100px;
                        "
                      >
                        <v-flex>
                          <v-layout>
                            <v-flex xs5 pl-3 mr-6 class="text-field-center">
                              <textfield-form-append
                                :model="form.signature"
                                css="font-weight: bold;"
                                label="ผู้วิจัย"
                                hide-detail
                                readonly
                              ></textfield-form-append>
                            </v-flex>
                            <v-flex xs4>
                              <textfield-form
                                :model="reportDate"
                                readonly
                              ></textfield-form>
                            </v-flex>
                          </v-layout>
                          <v-layout mt-n3 px-12>
                            <v-flex xs5>
                              <v-layout justify-center>
                                <v-flex shrink style="font-weight: bold">
                                  <span>(</span>
                                </v-flex>
                                <v-flex
                                  xs8
                                  mx-2
                                  mt-n3
                                  class="text-field-center"
                                >
                                  <textfield-form-append
                                    :model="form.signature"
                                    readonly
                                  />
                                </v-flex>
                                <v-flex shrink style="font-weight: bold">
                                  <span>)</span>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                          <v-layout style="margin-top: 30px">
                            <v-flex
                              ml-8
                              my-5
                              style="text-align: left; font-weight: bold"
                            >
                              <span>Note</span>
                            </v-flex>
                          </v-layout>
                          <v-layout>
                            <v-flex
                              style="padding-left: 32px; padding-right: 32px"
                            >
                              <textarea-form
                                @update-data="updateData('noteDetail', $event)"
                                :model="form.noteDetail"
                                :rows="5"
                              ></textarea-form>
                            </v-flex>
                          </v-layout>
                          <v-layout style="margin-top: -35px">
                            <v-flex
                              ml-8
                              my-5
                              style="text-align: left; font-weight: bold"
                            >
                              <span>การตรวจสอบ</span>
                            </v-flex>
                          </v-layout>
                          <v-layout
                            style="margin-left: 32px; margin-top: -15px"
                          >
                            <span style="font-weight: bold; padding-top: 19px"
                              >วันที่ผู้วิจัยรายงาน</span
                            >
                            <v-col cols="2" class="text-end text-field-center">
                              <DateInputForm
                                :model="researcherReportDate"
                                @update-data="
                                  updateData('researcherReportDate', $event)
                                "
                                style="font-weight: bold"
                              ></DateInputForm>
                            </v-col>
                          </v-layout>

                          <v-layout ml-n12 style="padding-top: 150px">
                            <v-flex
                              style="font-weight: bold"
                              d-flex
                              justify-start
                            >
                              <span
                                >สำนักงานคณะอนุกรรมการพิจารณาโครงการวิจัย
                                พบ.</span
                              >
                            </v-flex>
                            <v-flex
                              style="font-weight: bold"
                              d-flex
                              justify-end
                            >
                              <span>หน้า 1 จาก 1 หน้า</span>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
                <!--save button-->
                <v-layout mt-8>
                  <v-flex mb-12 style="text-align: left">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="$router.go(-1)"
                          >ย้อนกลับ</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex mb-12 style="text-align: right">
                    <v-layout>
                      <v-flex>
                        <v-btn
                          v-if="status == 'รอดำเนินการ'"
                          style="color: #3e7662"
                          class="mx-4"
                          depressed
                          color="#ffffff"
                          @click="saveEdit()"
                          ><v-icon>add</v-icon>บันทึกเพื่อแก้ไข</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
                <loading
                  color="#527281"
                  :active.sync="isLoading"
                  :can-cancel="false"
                  :is-full-pageAndLine="fullpageAndLine"
                ></loading>
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-content>
</template>

<script>
import TextfieldForm from "../../../components/input/TextfieldForm";
import TextareaForm from "../../../components/input/TextareaForm";
import DateInputForm from "../../../components/input/DateInputForm";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TextfieldFormAppend from "../../../components/input/TextfieldFormAppend";
import { mapState } from "vuex";
import domtoimage from "dom-to-image";
import Swal from "sweetalert2";

export default {
  name: "FormRF06",
  components: {
    TextfieldForm,
    TextareaForm,
    Loading,
    TextfieldFormAppend,
    DateInputForm,
  },
  data: () => ({
    isLoading: false,
    fullpageAndLine: true,
    selected: [],
    dialog: false,
    form: {
      fileOther: [],
      noteDetail: "",
      researcherReportDate: "",
      researchID: "",
      researchCode: "",
      firstName: "",
      lastName: "",
      researchName: "",
      amountOfReport: "",
      amountOfNotFollow: "",

      hasDeviation: "",
      hasProtocol: "",

      hasRandom: false,
      randomEventNumber: "",
      hasEnrollment: false,
      enrollmentEventNumber: "",
      hasNotScreening: false,
      notScreeningEventNumber: "",
      hasScreening: false,
      screeningEventNumber: "",
      hasFailureTherapy: false,
      failureTherapyEventNumber: "",
      hasFailureAccomplish: false,
      failureAccomplishEventNumber: "",
      hasFollowUp: false,
      followUpEventNumber: "",
      hasOther1: false,
      other1: "",
      hasNonCompliance: false,
      hasDelaySAEReport: false,
      delaySAEReportEventNumber: "",
      hasDelayContinuingReport: false,
      delayContinuingReportEventNumber: "",
      hasUseUnstampedInformed: false,
      useUnstampedInformedEventNumber: "",
      hasAccountabilityDrug: false,
      accountabilityDrugEventNumber: "",
      hasOther2: false,
      other2: "",
      summaryOfTheEvent: "",
      hasSubjectWithdraw: false,
      hasSubjectWithdrawWithFollowUp: false,
      hasSubjectRemainButFollow: false,
      hasSubjectRemainButStudy: false,
      hasSponsorNotified: false,
      sponsorNotifiedOnDate: "",
      hasOther3: "",
      other3: "",
      hasIncreaseRisk: "",
      hasCauseDamage: "",
      hasRetraining: "",
      retraining: "",
      hasGCPTraining: "",
      GCPTraining: "",
      hasHireStaff: "",
      hasIncreaseSecurity: "",
      increaseSecurity: "",
      hasFixOldMachine: "",
      hasOther4: "",
      other4: "",
      instituteBook: "",
      agencyBook: "",
      bookNumber: "",
      bookDate: "",

      signature: "",
      reportDate: "",
    },
    status: "",
    researcherReportDate: "",
    agencyBook: "",
    agencyBookLink: "",

    subjectData: [
      {
        subjectNumber: "",
        dateOfEvents: "",
        dateOfAcknowledgement: "",
      },
    ],
    researchAllHeaders: [
      { text: "Version", value: "version", align: "center" },
      { text: "หน้า / บรรทัด", value: "pageAndLine", align: "center" },
      { text: "ข้อมูลเดิม / ข้อเสนอแนะ", value: "suggestion", align: "center" },
      { text: "ลบ", value: "delete", align: "center" },
    ],
    userID: "",
    reportDate: "",
  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    this.getFormRF05();
  },
  methods: {
    async printPage() {
      this.printMode = true;
      document.getElementsByClassName("print-form")[0].style.backgroundColor =
        "#fff";
      await document.querySelectorAll("button").forEach(function(element) {
        element.style.display = "none";
      });
      await document.querySelectorAll(".v-icon").forEach(function(element) {
        element.style.display = "none";
      });
      await document
        .getElementsByClassName("v-input--checkbox v-input--is-label-active")
        .forEach(function(element) {
          element.innerHTML = "✓" + element.innerHTML;
        });
      await document
        .getElementsByClassName("v-radio v-item--active")
        .forEach(function(element) {
          element.innerHTML = "✓ " + element.innerHTML;
        });
      var node = document.getElementById("print");
      var self = this;
      domtoimage
        .toPng(node)
        .then(async function(dataUrl) {
          var img = new Image();
          img.src = dataUrl;
          var page = self.imageToPrint(img);

          var pageLink = "about:blank";
          var pwa = window.open(pageLink, "_new");
          pwa.document.open();
          pwa.document.write(page);
          pwa.document.close();
          self.printMode = false;
          await document.querySelectorAll("button").forEach(function(element) {
            element.style.display = "unset";
          });
          await document
            .getElementsByClassName(
              "v-input--checkbox v-input--is-label-active"
            )
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓", "");
            });
          await document
            .getElementsByClassName("v-radio v-item--active")
            .forEach(function(element) {
              element.innerHTML = element.innerHTML.replace("✓ ", "");
            });
          await document.querySelectorAll(".v-icon").forEach(function(element) {
            element.style.display = "unset";
          });
          document
            .getElementsByClassName("print-form")[0]
            .removeAttribute("style");
        })
        .catch(function(error) {
          Swal.fire({
            title: "กรุณาเปิดการอนุญาต Pop Up!",
            description: "",
            icon: "error",
            confirmButtonColor: "#3E7662",
            cancelButtonColor: "rgb(189, 189, 189)",
            confirmButtonText: "ตกลง",
          }).then(async function() {
            await document
              .querySelectorAll("button")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            await document
              .getElementsByClassName(
                "v-input--checkbox v-input--is-label-active"
              )
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓", "");
              });
            await document
              .getElementsByClassName("v-radio v-item--active")
              .forEach(function(element) {
                element.innerHTML = element.innerHTML.replace("✓ ", "");
              });
            await document
              .querySelectorAll(".v-icon")
              .forEach(function(element) {
                element.style.display = "unset";
              });
            document
              .getElementsByClassName("print-form")[0]
              .removeAttribute("style");
          });
        });
    },
    imageToPrint(source) {
      return (
        "<html><body onload='window.print()'><style>@media print {\n" +
        "  @page { margin: 0; }\n" +
        "  html, body {\n" +
        "    margin: 0;\n" +
        "    width: 210mm;\n" +
        "    height: 297mm;\n" +
        "  }\n" +
        "  img {\n" +
        "    margin-top: 10mm;\n" +
        "    margin-left: 20mm;\n" +
        "    width: 170mm;\n" +
        // "    height: 297mm;\n" +
        "  }\n" +
        "}</style>" +
        source.outerHTML +
        "</body></html>"
      );
    },
    saveEdit() {
      Swal.fire({
        title: "คุณต้องการบันทึกเพื่อแก้ไขหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่ บันทึกเพื่อแก้ไข",
      }).then((result) => {
        if (result.value) {
          this.form["researchID"] = this.$route.query.id;
          this.form["rfID"] = this.$route.query.rfID;

          this.isLoading = true;
          this.$store
            .dispatch("FormRF/saveEditRF05", this.form)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "บันทึกเพื่อแก้ไขสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.$router.push("/verify-rf");
              });
              console.log("res", res);

              this.isLoading = false;
            })
            .catch((e) => {
              this.isLoading = false;
              if (e.response.data.errors) {
                for (var k in e.response.data.errors) {
                  Swal.fire({
                    title: "เกิดข้อผิดพลาด",
                    text: e.response.data.errors[k][0],
                    icon: "warning",
                    confirmButtonColor: "#3E7662",
                  }).then(() => {
                    this.$vuetify.goTo(`#${k}`);
                  });
                }
              }
            });
        }
      });
    },
    updateData(name, val) {
      if (name === "researcherReportDate") {
        this.researcherReportDate = this.changeDate(val.date);
        this.form.researcherReportDate = val.date;
      }
      if (name === "noteDetail") {
        this.form.noteDetail = val;
      }
    },
    open() {
      window.open(this.agencyBookLink);
    },
    changeDate(val) {
      if (val != null) {
        //change date start
        let sub_year = val.substring(0, 4);
        let sub_month = val.substring(5, 7);
        let sub_day = val.substring(8, 10);
        sub_year = parseInt(sub_year) + 543;
        let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
        return changeDate;
      } else {
        return null;
      }
    },
    getFormRF05() {
      this.$store
        .dispatch("FormRF/getRF05", this.$route.query.rfID)
        .then((res) => {
          if (res !== "don't have deviation report yet") {
            this.form.fileOther = res.fileOther ?? [];
            this.form.instituteBook = res.instituteBook;
            this.status = res.status;
            this.form.noteDetail = res.noteDetail;
            this.form.researcherReportDate = res.noteDetailDate;
            this.researcherReportDate = this.changeDate(res.noteDetailDate);
            this.form.researchID = res.researchID;
            this.form.researchCode = res.researchCode;
            this.form.firstName = res.firstName;
            this.form.lastName = res.lastName;
            this.form.researchName = res.researchName;
            this.form.amountOfReport = res.amountOfReport;
            this.form.amountOfNotFollow = res.amountOfNotFollow;

            this.form.hasProtocol = res.hasProtocol == 1;
            this.form.hasDeviation = res.hasDeviation == 1;
            this.form.hasRandom = res.hasRandom == 1;
            this.form.hasEnrollment = res.hasEnrollment == 1;
            this.form.hasNotScreening = res.hasNotScreening == 1;
            this.form.hasScreening = res.hasScreening == 1;
            this.form.hasFailureTherapy = res.hasFailureTherapy == 1;
            this.form.hasFailureAccomplish = res.hasFailureAccomplish == 1;
            this.form.hasFollowUp = res.hasFollowUp == 1;
            this.form.hasOther1 = res.hasOther1 == 1;
            this.form.other1 = res.other1;
            this.form.hasNonCompliance = res.hasNonCompliance == 1;
            this.form.hasDelaySAEReport = res.hasDelaySAEReport == 1;
            this.form.hasDelayContinuingReport =
              res.hasDelayContinuingReport == 1;
            this.form.hasUseUnstampedInformed =
              res.hasUseUnstampedInformed == 1;
            this.form.hasAccountabilityDrug = res.hasAccountabilityDrug == 1;
            this.form.hasOther2 = res.hasOther2 == 1;
            this.form.other2 = res.other2;
            this.form.randomEventNumber = res.randomEventNumber;
            this.form.enrollmentEventNumber = res.enrollmentEventNumber;
            this.form.notScreeningEventNumber = res.notScreeningEventNumber;
            this.form.screeningEventNumber = res.screeningEventNumber;
            this.form.failureTherapyEventNumber = res.failureTherapyEventNumber;
            this.form.failureAccomplishEventNumber =
              res.failureAccomplishEventNumber;
            this.form.followUpEventNumber = res.followUpEventNumber;
            this.form.delaySAEReportEventNumber = res.delaySAEReportEventNumber;
            this.form.delayContinuingReportEventNumber =
              res.delayContinuingReportEventNumber;
            this.form.useUnstampedInformedEventNumber =
              res.useUnstampedInformedEventNumber;
            this.form.accountabilityDrugEventNumber =
              res.accountabilityDrugEventNumber;
            this.form.summaryOfTheEvent = res.summaryOfTheEvent;
            this.form.hasSubjectWithdraw = res.hasSubjectWithdraw == 1;
            this.form.hasSubjectWithdrawWithFollowUp =
              res.hasSubjectWithdrawWithFollowUp == 1;
            this.form.hasSubjectRemainButFollow =
              res.hasSubjectRemainButFollow == 1;
            this.form.hasSubjectRemainButStudy =
              res.hasSubjectRemainButStudy == 1;
            this.form.hasSponsorNotified = res.hasSponsorNotified == 1;
            this.form.sponsorNotifiedOnDate = res.sponsorNotifiedOnDate
              ? this.changeDate(res.sponsorNotifiedOnDate)
              : "";
            this.form.hasOther3 = res.hasOther3 == 1;
            this.form.other3 = res.other3;
            this.form.hasIncreaseRisk = res.hasIncreaseRisk.toString();
            this.form.hasCauseDamage = res.hasCauseDamage.toString();
            this.form.hasRetraining = res.hasRetraining == 1;
            this.form.retraining = res.retraining
              ? this.changeDate(res.retraining)
              : "";
            this.form.hasGCPTraining = res.hasGCPTraining == 1;
            this.form.GCPTraining = res.GCPTraining
              ? this.changeDate(res.GCPTraining)
              : "";
            this.form.hasHireStaff = res.hasHireStaff == 1;
            this.form.hasIncreaseSecurity = res.hasIncreaseSecurity == 1;
            this.form.increaseSecurity = res.increaseSecurity;
            this.form.hasFixOldMachine = res.hasFixOldMachine == 1;
            this.form.hasOther4 = res.hasOther4 == 1;
            this.form.other4 = res.other4;

            this.agencyBookLink = res.agencyBookPath;
            this.agencyBook = res.agencyBook;
            this.form.bookNumber = res.bookNumber;
            this.form.bookDate = !res.bookDate
              ? ""
              : this.changeDate(res.bookDate);

            this.form.signature = res.signature;
            this.form.reportDate = res.reportDate;
            this.reportDate = this.changeDate(res.reportDate);
            this.subjectData = res.deviation_report_subject_data;

            this.subjectData.forEach((data, i) => {
              data.dateOfEvents = data.dateOfEvents
                ? this.changeDate(data.dateOfEvents)
                : "";
              data.dateOfAcknowledgement = data.dateOfAcknowledgement
                ? this.changeDate(data.dateOfAcknowledgement)
                : "";
            });
          }
        });
    },
  },
};
</script>

<style lang="scss">
label.v-label.theme--light {
  color: #544a44;
}
.color-label-checkbox {
  label.v-label.theme--light {
    color: #3e7662;
  }
}
.v-text-field.v-input--dense:not(.v-text-field--outlined) input {
  text-align: center;
  padding: 4px 0 2px;
}
</style>
